<script setup>
import { computed } from 'vue'

const model = defineModel({ type: Array, default: () => [] })
const props = defineProps({
  areaGroups: { type: Array, default: () => [] },
})

const ZONE_ORDER = [2, 3, 6, 8, 9, 10, 11, 12, 13]

const zoneOptions = computed(() => {
  const sorted = [...props.areaGroups].sort(
    (a, b) => ZONE_ORDER.indexOf(a.id) - ZONE_ORDER.indexOf(b.id)
  )
  return [{ id: null, name: 'Everywhere' }, ...sorted.map(g => ({ id: g.id, name: g.label }))]
})

function areaIdsForZone(zoneId) {
  const group = props.areaGroups.find(g => g.id === zoneId)
  return group ? group.items.map(a => a.id) : []
}

const activeZoneIds = computed(() => {
  if (model.value.length === 0) return [null]
  return ZONE_ORDER.filter(zid => areaIdsForZone(zid).some(id => model.value.includes(id)))
})

function onZoneChange(newVal) {
  const old     = activeZoneIds.value
  const added   = newVal.filter(id => !old.includes(id))
  const removed = old.filter(id => !newVal.includes(id))

  let result = [...model.value]

  for (const id of added) {
    if (id === null) { model.value = []; return }
    const toAdd = areaIdsForZone(id).filter(a => !result.includes(a))
    result = [...result, ...toAdd]
  }
  for (const id of removed) {
    if (id === null) return
    const toRemove = new Set(areaIdsForZone(id))
    result = result.filter(a => !toRemove.has(a))
  }

  model.value = result
}
</script>

<template lang="pug">
SelectButton(
  :options="zoneOptions"
  :modelValue="activeZoneIds"
  optionLabel="name"
  optionValue="id"
  multiple
  @update:modelValue="onZoneChange"
  size="large"
)
</template>

<!-- <style lang="scss">
@layer components {
  .p-multiselect-list-container {
    max-height: 70vh;
  }
}
</style> -->